import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { sheet, tabsNav } = semanticThemeTokens;

// Main container for the SheetTabs component
export const sheetTabsContainer = style({
  display: "flex",
  flexDirection: "column",
  height: "100%"
});

// Sticky wrapper for the header section
export const sheetTabsHeaderWrap = style({
  position: "sticky",
  top: 0,
  zIndex: 2,
  width: "100%"
});

// Inner layout for header elements (tabs, slots, controls)
export const sheetTabsHeaderInner = style({
  display: "flex",
  alignContent: "center",
  justifyContent: "space-between",
  gap: primitiveTokens.sizing["2x"],
  paddingLeft: 0,
  paddingTop: 0,
  paddingRight: primitiveTokens.sizing["4x"],
  minWidth: 0
});

// Horizontal list for tab triggers with overflow handling
export const sheetTabsList = style({
  display: "flex",
  flexWrap: "nowrap",
  overflowX: "auto",
  overflowY: "hidden",
  scrollbarWidth: "thin",
  minWidth: 0
});

// Individual tab trigger button with state-based styling
export const sheetTabsTrigger = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignContent: "center",
  gap: primitiveTokens.sizing["2.5x"],
  minHeight: primitiveTokens.sizing["10x"],
  fontSize: tabsNav.fontSize,
  cursor: "pointer",
  background: tabsNav.default.backgroundColor,
  color: tabsNav.default.textColor,
  borderColor: "transparent",
  borderWidth: "thick",
  padding: primitiveTokens.sizing["2.5x"],
  minWidth: 120,
  whiteSpace: "nowrap",
  selectors: {
    "&:hover": {
      backgroundColor: tabsNav.hover.backgroundColor,
      color: tabsNav.hover.textColor
    },
    "&:focus-visible": {
      outline: "none",
      backgroundColor: sheet.layer1.backgroundColor
    },
    '&[data-state="active"]': {
      backgroundColor: tabsNav.active.backgroundColor,
      color: tabsNav.active.textColor
    },
    "&[data-disabled]": {
      opacity: 0.5,
      cursor: "not-allowed"
    }
  }
});

// Content area for tab panels with scroll and background
export const sheetTabsContent = style({
  fontSize: tabsNav.fontSize,
  padding: primitiveTokens.sizing["3x"],
  gap: primitiveTokens.sizing["6x"],
  display: "block",
  overflow: "auto !important",
  opacity: 1,
  backgroundColor: tabsNav.active.backgroundColor,
  flex: 1,
  minHeight: 0
});

// Override for Sheet component in navigation context
export const sheetTabsSheetStyle = style({
  padding: 0
});

// Border radius when the first tab is selected
export const sheetTabsBorderRadiusFirstSelected = style({
  borderRadius: `0 ${primitiveTokens.sizing["6x"]} 0 0`
});

// Default border radius for other tabs
export const sheetTabsBorderRadiusDefault = style({
  borderRadius: `${primitiveTokens.sizing["6x"]} ${primitiveTokens.sizing["6x"]} 0 0`
});
